// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__rvJcA","options":"AnswerScale_options__P1hqc","selected":"AnswerScale_selected__1CHb0"};